import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateMotibellViewCount } from "lib/api/motibell/updateMotibellViewCount"

const useUpdateMotibellViewCount = ({ userNo }) => {
  const queryClient = useQueryClient()
  return useMutation(({ motibellNo }) => updateMotibellViewCount({ motibellNo }), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["motibellMainList", userNo] })
    },
  })
}

export default useUpdateMotibellViewCount
